import { v4 as uuid } from "uuid";
import moment from "moment";
import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import BMW_Img1 from "./products/BMW_1.png";
const products = [
  {
    id: uuid(),
    name: "WBA1234555",
    imageUrl: BMW_Img1,
    updatedAt: moment().subtract(2, "hours"),
  },
  {
    id: uuid(),
    name: "WBA1234556",
    imageUrl: BMW_Img1,
    updatedAt: moment().subtract(2, "hours"),
  },
  {
    id: uuid(),
    name: "WBA1234557",
    imageUrl: BMW_Img1,
    updatedAt: moment().subtract(3, "hours"),
  },
  {
    id: uuid(),
    name: "WBA1234558",
    imageUrl: BMW_Img1,
    updatedAt: moment().subtract(5, "hours"),
  },
  {
    id: uuid(),
    name: "WBA1234559",
    imageUrl: BMW_Img1,
    updatedAt: moment().subtract(9, "hours"),
  },
];

const LatestProducts = (props) => (
  <Card {...props} sx={{ background: "#eee" }}>
    <CardHeader
      subtitle={`${products.length} in total`}
      title="최근 신청서 발급차량(개발중)"
    />
    <Divider />
    <List>
      {products.map((product, i) => (
        <ListItem divider={i < products.length - 1} key={product.id}>
          <ListItemAvatar>
            <img
              alt={product.name}
              src={product.imageUrl}
              style={{
                height: 48,
                width: 48,
              }}
            />
          </ListItemAvatar>
          <ListItemText secondary={`Updated ${product.updatedAt.fromNow()}`}>
            <a href={`/search/${product.name}`}>{product.name}</a>
          </ListItemText>
          <IconButton edge="end" size="small">
            <MoreVertIcon />
          </IconButton>
        </ListItem>
      ))}
    </List>
    <Divider />
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        p: 2,
      }}
    >
      <Button
        color="primary"
        endIcon={<ArrowRightIcon />}
        size="small"
        variant="text"
      >
        View all
      </Button>
    </Box>
  </Card>
);

export default LatestProducts;
